import $ from 'jquery';
import Splitting from 'splitting';

import { $Elements, Events } from '../global/constants';

// ---------- Init Base Animation ----------

export const initBaseAnimations = () => {

	$('.links-section .link-card .text').each(function() {

		const originalText = this.textContent.trim();
		const results = Splitting({ target: this });

		this.setAttribute('aria-label', originalText);
		this.querySelectorAll('.char, .word, .line').forEach(child => {
			child.setAttribute('aria-hidden', 'true');
		});
	});

	$('.content-section:not(.links-section) .content > *').each(function() {
		if(document.documentElement.lang === 'zh-CN') {
			const infosColumn = this.querySelector('.infos-column');

			if(infosColumn) {
				$('.wine-infos').addClass('words lines splitting');
				$('.wine-infos').wrapInner('<span class="word"></span>');
			}
			else {
				$(this).not('.wine-details').addClass('words lines splitting');
				$(this).not('.wine-details').wrapInner('<span class="word"></span>');
			}
		}
		else {
			const originalText = this.textContent.trim();
			const results = Splitting({ target: this, by: 'lines' });

			this.setAttribute('aria-label', originalText);
			this.querySelectorAll('.char, .word, .line').forEach(child => {
				child.setAttribute('aria-hidden', 'true');
			});
		}
	});
};

$Elements.document.on(Events.page.enter, () => initBaseAnimations());
